<template>
  <v-dialog
    v-if="type === 'dialog'"
    @click:outside="close"
    :fullscreen="ifMobile"
    :max-width="!ifMobile && width ? width : '100%'"
    :hide-overlay="ifMobile"
    :id="id"
    content-class="card-dialog"
    scrollable
    v-model="dialogStatus"
    style="margin-left: 40px !important;"
  >
    <v-card
      class="v-card--material dialog-card"
      v-bind="
      $attrs"
    >
      <div class="close-button">
        <v-btn
          color="green darken-1"
          icon
          @click="close"
        >
          <v-icon size="32">mdi-close</v-icon>
        </v-btn>
      </div>
      <v-card-title
        class="pu-0"
        :style="ifMobile ? 'padding: 0px;' : 'height: 100px; padding: 0px;'"
      >
        <div>
          <v-sheet
            v-if="!ifMobile"
            :color="color"
            elevation="6"
            style="float: left"
            class="card-icon-container text-start mb-n6 pa-7"
            dark
          >
            <v-icon
              class="card-icon"
              v-if="icon"
              size="40"
              v-text="icon"
            />
          </v-sheet>
          <div
            class="text-center card-title font-weight-light"
            :style="
              'float: left; ' +
              (!ifMobile
                ? 'line-height: 60px; width: calc(100% - 100px); margin-left: 100px;'
                : 'width: 100%')
            "
          >
            <h3
              :class="color + '--text'"
              v-html="title"
            />
            <div
              v-if="text && text !== ''"
              v-html="text"
            />
            <slot
              v-else
              name="header"
            />
          </div>
        </div>
      </v-card-title>
      <v-divider class="mt-2" />

      <v-card-text class="card-text">
        <slot />
      </v-card-text>

      <template v-if="$slots.actions">
        <v-divider class="mt-2" />

        <v-card-actions style="overflow: hidden">
          <slot name="actions" />
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
  <base-material-card
    v-else-if="type === 'card'"
    :title="title"
    :text="text"
    :color="color"
    :icon="icon"
  >
    <slot />
    <template v-if="$slots.actions">
      <v-divider class="mt-2" />

      <v-card-actions style="overflow: hidden">
        <slot name="actions" />
      </v-card-actions>
    </template>
  </base-material-card>
  <div v-else-if="type === 'plain'">
    <slot />
    <template v-if="$slots.actions">
      <v-divider class="mt-2" />

      <v-card-actions style="overflow: hidden">
        <slot name="actions" />
      </v-card-actions>
    </template>
  </div>
</template>

<script>
export default {
  name: "dialog-form",

  props: {
    color: {
      type: String,
      default: "success",
    },
    value: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: undefined,
    },
    type: {
      type: String,
      default: "dialog",
    },
    text: {
      type: String,
      default: "",
    },
    width: {
      type: String,
      default: "100%",
    },
    title: {
      type: String,
      default: "",
    },id: {
      type: String,
      default: "id",
    },zIndex: {
      type: Number,
      default: null,
    },
  onOpen: { type: Function, default: null },
  },
  data() {
    return {
      dialogStatus: false,
      windowWidth: window.innerWidth,
    };
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
    });
  },
  methods: {
    open() {
      this.dialogStatus = true;
      //if (this.onOpen) this.onOpen();
    },
    close() {
      this.dialogStatus = false;
      this.$emit("input", this.dialogStatus);
    },
    waitForElm(selector) {
      return new Promise(resolve => {
        if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
          if (document.querySelector(selector)) {
            resolve(document.querySelector(selector));
            observer.disconnect();
          }
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      });
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      // watch it
      this.dialogStatus = this.value;
    },
    dialogStatus(newVal, oldVal) {
      if (newVal && this.onOpen) {
        this.waitForElm('#'+this.id).then((elm) => {
          this.onOpen();
        });
      }
    }
  },
  computed: {
    ifMobile() {
      if (this.windowWidth <= 648) return true;
      else return null;
    },
    headerHeight() {
      return "60px";
    },
  },
};
</script>
<style scoped>
.card-icon-container {
  height: 80px;
  width: 80px;
  position: absolute;
  left: 10px;
  top: 10px !important;
  padding: 0px !important;
}
.card-icon {
  position: absolute !important;
  top: 20px !important;
  right: 20px !important;
  color: white !important;
  opacity: 1 !important;
}
.card-text {
  overflow-x: hidden;
  padding-left: 0px;
  padding-right: 0px;
}

.close-button {
  position: absolute;
  top: 5px;
  right: 5px;

  z-index: 10;
}
.v-card--material--heading {
  position: relative;
  top: -40px !important;
  transition: 0.3s ease;
  z-index: 1;
}
</style>
